"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathValidationRegExp = exports.CustomAttributesMandatoryRpcActions = exports.CustomAttributeConsumerEntity = exports.CustomAttributesRpcActions = exports.CustomAttributeResolverType = exports.CustomAttributeDataType = exports.CustomAttributeEntityType = void 0;
var CustomAttributeEntityType;
(function (CustomAttributeEntityType) {
    CustomAttributeEntityType[CustomAttributeEntityType["Task"] = 0] = "Task";
    CustomAttributeEntityType[CustomAttributeEntityType["Waypoint"] = 1] = "Waypoint";
    CustomAttributeEntityType[CustomAttributeEntityType["Customer"] = 2] = "Customer";
    CustomAttributeEntityType[CustomAttributeEntityType["Team"] = 3] = "Team";
    CustomAttributeEntityType[CustomAttributeEntityType["User"] = 4] = "User";
})(CustomAttributeEntityType || (exports.CustomAttributeEntityType = CustomAttributeEntityType = {}));
var CustomAttributeDataType;
(function (CustomAttributeDataType) {
    CustomAttributeDataType[CustomAttributeDataType["Number"] = 0] = "Number";
    CustomAttributeDataType[CustomAttributeDataType["String"] = 1] = "String";
    CustomAttributeDataType[CustomAttributeDataType["Boolean"] = 2] = "Boolean";
    CustomAttributeDataType[CustomAttributeDataType["Enum"] = 3] = "Enum";
})(CustomAttributeDataType || (exports.CustomAttributeDataType = CustomAttributeDataType = {}));
var CustomAttributeResolverType;
(function (CustomAttributeResolverType) {
    CustomAttributeResolverType["JSONata"] = "JSONata";
})(CustomAttributeResolverType || (exports.CustomAttributeResolverType = CustomAttributeResolverType = {}));
var CustomAttributesRpcActions;
(function (CustomAttributesRpcActions) {
    CustomAttributesRpcActions["GetAll"] = "get_all";
    CustomAttributesRpcActions["GetAllByIds"] = "get_all_by_ids";
    CustomAttributesRpcActions["GetAllInternal"] = "get_all_internal";
    CustomAttributesRpcActions["UpsertSuggestion"] = "upsert_suggestion";
    CustomAttributesRpcActions["CheckUsage"] = "custom_attributes:check_record_usage";
    CustomAttributesRpcActions["UpdateValuesForEntities"] = "update_values_for_entities";
})(CustomAttributesRpcActions || (exports.CustomAttributesRpcActions = CustomAttributesRpcActions = {}));
var CustomAttributeConsumerEntity;
(function (CustomAttributeConsumerEntity) {
    CustomAttributeConsumerEntity["AnalyticsReport"] = "analytics_report";
    CustomAttributeConsumerEntity["Rule"] = "rule";
    CustomAttributeConsumerEntity["WorkflowRule"] = "workflow_rule";
    CustomAttributeConsumerEntity["WorkflowTrigger"] = "workflow_trigger";
    CustomAttributeConsumerEntity["WorkflowAction"] = "workflow_action";
})(CustomAttributeConsumerEntity || (exports.CustomAttributeConsumerEntity = CustomAttributeConsumerEntity = {}));
var CustomAttributesMandatoryRpcActions;
(function (CustomAttributesMandatoryRpcActions) {
    CustomAttributesMandatoryRpcActions["CheckUsage"] = "custom-attributes:check-record-usage";
})(CustomAttributesMandatoryRpcActions || (exports.CustomAttributesMandatoryRpcActions = CustomAttributesMandatoryRpcActions = {}));
exports.pathValidationRegExp = /^[a-zA-Z_$\d]+(\[\d+\])*?$/;
//# sourceMappingURL=custom_attribute.js.map